import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Coins = createReactComponent("Coins", ["svg", defaultAttributes, [["circle", {
  cx: "8",
  cy: "8",
  r: "7",
  key: "j6dzdq"
}], ["path", {
  d: "M19.5 9.94a7 7 0 11-9.56 9.56",
  key: "1crc7a"
}], ["path", {
  d: "M7 6h1v4",
  key: "190gst"
}], ["path", {
  d: "M17.3 14.3l.7.7-2.8 2.8",
  key: "1je1e1"
}]]]);
export default Coins;